module.exports = __webpack_public_path__ + "static/scale-model-of-historic-miller-caves-in-milwaukee-wisconsin-bdbce7ee5633e415fc448d067e71c530.png";